export default {
	"delivery.ThereIsNoLogisticalInformation": "暫無任何物流資訊",
	"delivery.ParameterError": "參數錯誤！"
}